// extracted by mini-css-extract-plugin
module.exports =  {"prefixBlock":"prefixBlock__r4E27","info":"info__fRSM-","error":"error__JS55k"};